<template>
    <div>
        ZAGLUSHKA STATISTIC AFFILIATE 😎
    </div>
</template>

<script>
export default {
    name: "StatisticAffiliate"
}
</script>

<style scoped>

</style>
